import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import DeclarationMaintenanceService from '../services/DeclarationMaintenanceService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import VehiculeService from '../services/VehiculeService';
import { Calendar } from 'primereact/calendar';
import CvaService from '../services/CvaService';

const DeclarationMaintenance = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        DeclarationMaintenanceService.get((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {size: itemPerPage}
        );
    }

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                DeclarationMaintenanceService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }
    
    return (
        <>
            <h5>Liste des déclaration de maintenances</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} */
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="numeroDeclaration" header="Numéro déclaration" sortable />
                <Column field="dateDevis" header="Date devis" sortable 
                    body={(item)=> new Date(item.dateDevis).toLocaleDateString()}/>
                <Column field="panneConstatee" header="Panne constatée" sortable style={{fontWeight: 'bold'}} />
                <Column field="referenceDevis" header="Référence devis" sortable />
                <Column field="releveKilometrage" header="Relevé kilométrage" sortable 
                    body={item => item.releveKilometrage?.toLocaleString()} />
                <Column field="seuilAlerte" header="Seuil alerte" sortable body={item => item.seuilAlerte?.toLocaleString()}/>
                <Column field="texte" header="Texte" sortable />
                <Column field="vehicule.immatriculation" header="Véhicule" sortable />
                <Column header="Nom et prénoms" sortable body={(item)=> item.cva.nom + " " + item.cva.prenom}/>
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const [chauffeurs, setChauffeurs] = useState([]);
    const [vehicules, setVehicules] = useState([]);

    useEffect(()=> {
        if(!visible) return;
        CvaService.get((data)=> data && setChauffeurs(data), {size: pageMaxSize})
    }, [visible]);

    //console.log(chauffeurs);

    useEffect(()=> {
        if(!visible) return;
        VehiculeService.get((data)=> data && setVehicules(data), {size: pageMaxSize})
    }, [visible]);
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) DeclarationMaintenanceService.update(data, onResponse); else DeclarationMaintenanceService.add(data, onResponse);
                },
            }
        )
    
    }

    return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails d'une déclaration maintenance" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
            >  
                <div className="field" hidden>
                    <label htmlFor="id">Identifiant</label>
                    <InputText id="id" value={data && data.id} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="ReferenceCava">Référence CVA</label>
                    <InputText id="ReferenceCava" value={data && data.ReferenceCava} 
                        onChange={bind} required placeholder=" " autoFocus />
                </div>
                <div className="field">
                    <label htmlFor="dateDevis">Date devis</label>
                    <InputText type="date" id="dateDevis" value={data && data.dateDevis} onChange={bind}/>
                </div>
                <div className="field">
                    <label htmlFor="montantDevis">Montant devis</label>
                    <InputNumber id="montantDevis" value={data && data.montantDevis} 
                        onValueChange={bind} required keyfilter="num" />
                </div>
                <div className="field">
                    <label htmlFor="numeroDeclaration">Numéro déclaration</label>
                    <InputText id="numeroDeclaration" value={data && data.numeroDeclaration} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="panneConstatee">Panne constatée</label>
                    <InputText id="panneConstatee" value={data && data.panneConstatee} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="cva">CVA</label>
                    <Dropdown id="cva" options={chauffeurs} value={data?.cva} onChange={bind}
                        optionLabel = {(cva)=> cva.nom + " " + cva.prenom }
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="vehicule">Matériel roulant</label>
                    <Dropdown id="vehicule" options={vehicules} value={data?.vehicule} onChange={bind}
                        optionLabel="immatriculation" 
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="referenceDevis">Référence devis</label>
                    <InputText id="referenceDevis" value={data && data.referenceDevis} onChange={bind} placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="releveKilometrage">Relevé kilométrage</label>
                    <InputNumber id="releveKilometrage" value={data && data.releveKilometrage} 
                        onValueChange={bind} required keyfilter="num" />
                </div>
                <div className="field">
                    <label htmlFor="seuilAlerte">Seuil alerte</label>
                    <InputNumber id="seuilAlerte" value={data && data.seuilAlerte} onValueChange={bind} 
                        placeholder="" keyfilter="num" />
                </div>
                <div className="field">
                    <label htmlFor="texte">Texte</label>
                    <InputText id="texte" value={data && data.texte} onChange={bind} 
                        placeholder="" />
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default DeclarationMaintenance;